<template>
    <div class="personnel-management">
        <!-- 搜索和筛选区域 -->
        <div class="search-panel">
            <el-form :inline="true" :model="searchForm" class="search-form">
                <el-form-item label="角色名称" class="form-item">
                    <el-input v-model="searchForm.roleName" placeholder="请输入角色名称" clearable
                        class="search-input"></el-input>
                </el-form-item>

                <el-form-item label="角色编码" class="form-item">
                    <el-input v-model="searchForm.roleCode" placeholder="请输入角色编码" clearable
                        class="search-input"></el-input>
                </el-form-item>

                <el-form-item class="form-item operate-btns">
                    <el-button type="primary" @click="getList" class="search-btn">
                        <i class="fa fa-search mr-1"></i>搜索
                    </el-button>
                    <el-button type="default" @click="resetSearch" class="reset-btn">重置</el-button>
                    <el-button type="primary" @click="showAddDialog" class="add-btn">
                        <i class="fa fa-plus mr-2"></i>新增角色
                    </el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- 角色表格 -->
        <div class="table-container">
            <el-table :data="pagedPersonnel" border stripe :header-cell-style="tableHeaderStyle"
                @selection-change="handleSelectionChange" class="personnel-table" v-loading="loading"
                element-loading-text="加载中..." element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)" height="66vh">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column label="序号" type="index" width="60" align="center">
                    <template slot-scope="scope">
                        {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="roleName" label="角色名称" min-width="130" align="center"></el-table-column>
                <el-table-column prop="roleCode" label="角色编码" min-width="130" align="center"></el-table-column>
                <el-table-column prop="roleType" label="角色类型" min-width="130" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.roleType == 1">系统角色</span>
                        <span v-if="scope.row.roleType == 2">自定义角色</span>
                        <!-- <span v-else>{{ scope.row.roleType }}</span> -->
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="status" label="角色状态" min-width="100" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status === 1" class="status-active">启用</span>
                        <span v-else class="status-inactive">禁用</span>
                    </template>
                </el-table-column> -->
                <!-- <el-table-column prop="createTime" label="创建时间" min-width="120" align="center">
                    <template slot-scope="scope">
                        {{ formatDate(scope.row.createTime) }}
                    </template>
                </el-table-column> -->
                <el-table-column label="操作" min-width="180" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" class="edit-btn" @click="showEditDialog(scope.row)">
                            <i class="fa fa-pencil mr-1"></i>编辑
                        </el-button>
                        <el-button type="text" size="small" class="delete-btn" @click="handleDelete(scope.row)">
                            <i class="fa fa-trash-o mr-1"></i>删除
                        </el-button>
                        <el-button type="text" size="small" class="auth-btn" @click="handleAuth(scope.row)">
                            <i class="fa fa-key mr-1"></i>权限配置
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[5, 10, 20, 50]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="filteredPersonnel.length" class="pagination"
                :disabled="loading">
            </el-pagination>
        </div>

        <!-- 新增/编辑角色弹窗 -->
        <el-dialog :title="dialogType === 'add' ? '新增角色' : '编辑角色'" :visible.sync="dialogVisible" :width="dialogWidth"
            :close-on-click-modal="false" :z-index="3000" append-to-body>
            <el-form :model="form" :rules="formRules" ref="formRef" label-width="100px" class="form-modal">
                <el-row :gutter="20">
                    <el-col :span="24" :sm="12">
                        <el-form-item label="角色名称" prop="roleName">
                            <el-input v-model="form.roleName" placeholder="请输入角色名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" :sm="12">
                        <el-form-item label="角色编码" prop="roleCode">
                            <el-input v-model="form.roleCode" placeholder="请输入角色编码"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" :sm="12">
                        <el-form-item label="角色类型" prop="roleType">
                            <el-select v-model="form.roleType" placeholder="请选择角色类型">
                                <el-option label="系统角色" value="1"></el-option>
                                <el-option label="自定义角色" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" :sm="12">
                        <el-form-item label="角色状态" prop="status">
                            <el-select v-model="form.status" placeholder="请选择角色状态">
                                <el-option label="启用" value="1"></el-option>
                                <el-option label="禁用" value="0"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" :sm="12">
                        <el-form-item label="组织名称" prop="orgId">
                            <el-select v-model="form.orgId" placeholder="请选择组织名称">
                                <el-option v-for="dept in departments" :key="dept.orgId" :label="dept.orgName"
                                    :value="dept.orgId"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm()">确定</el-button>
            </div>
        </el-dialog>

        <!-- 权限配置弹窗 -->
        <el-dialog title="角色权限配置" :visible.sync="authDialogVisible" width="40%" :close-on-click-modal="false"
            :z-index="3000" append-to-body>
            <div class="auth-container">
                <el-tree :data="authTree" show-checkbox node-key="id" ref="authTreeRef" :props="treeProps"
                    :default-checked-keys="checkedAuthIds" @check="handleTreeCheck" :check-strictly="false"
                    v-loading="authLoading" element-loading-text="加载权限数据中...">
                </el-tree>
            </div>
            <div slot="footer">
                <el-button @click="authDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="saveAuth()" :loading="saveAuthLoading">保存权限</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getRoleList, addRole, editRole, delRole, getRoleMenuByRole, editPermission } from '@/api/role';
import { getOrgList } from "@/api/organization";
export default {
    data() {
        return {
            // 角色数据
            personnelList: [],        // 原始角色列表
            filteredPersonnel: [],    // 筛选后角色列表
            pagedPersonnel: [],       // 分页后角色列表

            // 搜索表单
            searchForm: {
                roleName: null,
                roleCode: null
            },

            // 分页信息
            currentPage: 1,
            pageSize: 10,
            loading: false,
            authLoading: false,       // 权限树加载状态
            saveAuthLoading: false,   // 保存权限加载状态

            // 选中的角色ID
            selectedIds: [],

            // 弹窗状态
            dialogVisible: false,
            authDialogVisible: false,
            dialogType: 'add',
            dialogWidth: '700px',

            // 当前操作的角色ID
            currentRoleId: '',

            // 表单数据
            form: {
                roleId: '',
                roleCode: '',
                roleName: '',
                roleType: '',
                orgId: '',
                status: 1 // 默认启用
            },
            // 权限树相关
            authTree: [],              // 权限树数据（包含status字段）
            checkedAuthIds: [],        // 根据status计算的勾选ID
            treeProps: {
                label: 'title',
                children: 'children'
            },
            tempCheckedIds: [],        // 临时存储勾选的权限ID
            departments: [],           // 组织列表
            checkRecords: []           // 格式: [{ id: 1, status: '1', time: 1620000000000 }, ...]
        };
    },

    computed: {
        // 表单验证规则
        formRules() {
            return {
                roleName: [
                    { required: true, message: '请输入角色名称', trigger: 'blur' },
                    { min: 1, max: 50, message: '角色名称长度需在1-50字符之间', trigger: 'blur' }
                ],
                roleCode: [
                    { required: true, message: '请输入角色编码', trigger: 'blur' },
                    { pattern: /^[A-Za-z0-9_-]{3,20}$/, message: '编码仅支持字母、数字、_、-，长度3-20字符', trigger: 'blur' }
                ],
                roleType: [
                    { required: true, message: '请选择角色类型', trigger: 'change' }
                ],
                status: [
                    { required: true, message: '请选择角色状态', trigger: 'change' }
                ]
            };
        },
        // 表格表头样式
        tableHeaderStyle() {
            return {
                background: '#f5f7fa',
                color: '#1D2129',
                fontWeight: '500'
            };
        },
        // 获取本地存储的userId
        userId() {
            return localStorage.getItem('userId');
        }
    },

    created() {
        // 初始化数据：先获取角色列表，再获取组织列表
        this.getList();
        this.getOrgList();
    },

    methods: {
        // 1. 获取组织列表
        getOrgList() {
            this.loading = true;
            getOrgList({ tenantId: null }).then(response => {
                this.departments = response.data || [];
            }).catch(error => {
                console.error('获取组织列表失败:', error);
                this.$message.error('加载组织列表失败');
            }).finally(() => {
                this.loading = false;
            });
        },

        // 2. 获取权限树数据（修复核心：返回Promise + 独立加载状态）
        getAuthTreeData() {
            // 关键修复：返回Promise对象
            return new Promise((resolve, reject) => {
                console.log(reject);

                this.authLoading = true;
                getRoleMenuByRole({ roleId: this.currentRoleId })
                    .then(response => {
                        const originTree = response.data
                        // 补全所有节点的id字段
                        this.authTree = this.completeTreeIds(originTree);
                        console.log(this.authTree);

                        // 同步角色权限状态
                        this.syncRoleAuthStatus();
                        resolve(this.authTree);
                    })
                    .catch(error => {
                        console.error('获取权限树失败:', error);
                        this.$message.error('加载权限列表失败');
                        // 使用假数据兜底
                        this.authTree = [
                            {
                                menuId: 1,
                                id: 1,
                                index: "1",
                                path: "/index",
                                title: "首页",
                                icon: "el-icon-menu",
                                status: '1',
                                children: []
                            },
                            {
                                menuId: 2,
                                id: 2,
                                index: "2",
                                path: "/device",
                                title: "设备管理",
                                icon: "el-icon-menu",
                                status: '0',
                                children: [
                                    {
                                        id: 3,
                                        index: "2-1",
                                        path: "/device/list",
                                        title: "设备列表",
                                        icon: "el-icon-menu",
                                        status: '0',
                                        children: []
                                    }
                                ]
                            }
                        ];
                        resolve(this.authTree);
                    })
                    .finally(() => {
                        this.authLoading = false;
                    });
            });
        },

        // 辅助方法1：补全权限树所有节点的id字段
        completeTreeIds(nodes) {
            if (!nodes || !Array.isArray(nodes)) return [];
            return nodes.map(node => {
                const newNode = {
                    ...node,
                    id: node.id || node.menuId || node.id, // 兼容不同的id字段名
                    status: node.status || '0'
                };
                // 递归处理子节点
                if (node.children && node.children.length > 0) {
                    newNode.children = this.completeTreeIds(node.children);
                }
                return newNode;
            });
        },

        // 辅助方法2：同步当前角色已有的权限状态
        syncRoleAuthStatus() {
            // 收集所有status为'1'的节点ID
            this.checkedAuthIds = [];
            this.traverseTree(this.authTree);
        },

        // 辅助方法3：根据已选权限ID更新树节点的status
        updateTreeStatusByAuthIds(nodes, authids) {
            if (!nodes || !Array.isArray(nodes)) return;
            nodes.forEach(node => {
                node.status = authids.includes(node.id) ? '1' : '0';
                if (node.children && node.children.length > 0) {
                    this.updateTreeStatusByAuthIds(node.children, authids);
                }
            });
        },

        // 3. 获取角色列表
        getList() {
            return new Promise((resolve) => {
                this.loading = true;
                getRoleList({ userId: this.userId })
                    .then(response => {
                        this.personnelList = response.data || [];
                        this.filterPersonnel();
                    })
                    .catch(error => {
                        console.error('获取角色列表失败:', error);
                        const errorMsg = error.response?.data?.message || '加载角色列表失败';
                        this.$message.error(errorMsg);
                        this.personnelList = [];
                    })
                    .finally(() => {
                        this.loading = false;
                        resolve();
                    });
            });
        },

        // 4. 筛选角色数据
        filterPersonnel() {
            let result = [...this.personnelList];
            if (this.searchForm.roleName) {
                const keyword = this.searchForm.roleName.toLowerCase();
                result = result.filter(item => item.roleName?.toLowerCase().includes(keyword));
            }
            if (this.searchForm.roleCode) {
                const keyword = this.searchForm.roleCode.toLowerCase();
                result = result.filter(item => item.roleCode?.toLowerCase().includes(keyword));
            }
            this.filteredPersonnel = result;
            this.paginateData();
        },

        // 5. 分页处理
        paginateData() {
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            this.pagedPersonnel = this.filteredPersonnel.slice(startIndex, endIndex);
        },

        // 6. 重置搜索条件
        resetSearch() {
            this.searchForm = { roleName: null, roleCode: null };
            this.currentPage = 1;
            this.filterPersonnel();
        },

        // 7. 显示新增弹窗
        showAddDialog() {
            this.dialogType = 'add';
            this.form = { roleId: '', roleCode: '', roleName: '', roleType: '', orgId: '', status: 1 };
            this.dialogVisible = true;
            this.$nextTick(() => this.$refs.formRef?.clearValidate());
        },

        // 8. 显示编辑弹窗
        showEditDialog(row) {
            this.dialogType = 'edit';
            this.form = { ...row };
            this.dialogVisible = true;
            this.$nextTick(() => this.$refs.formRef?.clearValidate());
        },

        // 9. 提交表单（新增/编辑）
        submitForm() {
            this.$refs.formRef.validate((isValid) => {
                if (!isValid) return;
                this.loading = true;
                const request = this.dialogType === 'add'
                    ? addRole({ ...this.form, userId: this.userId })
                    : editRole(this.form);
                request.then(response => {
                    if (response.code === 200) {
                        this.$message.success(`${this.dialogType === 'add' ? '新增' : '编辑'}角色成功`);
                        this.dialogVisible = false;
                        this.getList();
                    } else {
                        this.$message.error(`${this.dialogType === 'add' ? '新增' : '编辑'}角色失败`);
                    }
                }).catch(error => {
                    console.error('操作失败:', error);
                    this.$message.error(`${this.dialogType === 'add' ? '新增' : '编辑'}角色失败`);
                }).finally(() => {
                    this.loading = false;
                });
            });
        },

        // 10. 处理删除
        handleDelete(row) {
            this.$confirm(
                `确定要删除角色「${row.roleName}」吗？删除后数据不可恢复！`,
                '确认删除',
                { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }
            ).then(() => {
                this.loading = true;
                delRole({ id: row.id })
                    .then(response => {
                        if (response.code === 200) {
                            this.$message.success('删除角色成功');
                            this.getList();
                        } else {
                            this.$message.error('删除角色失败');
                        }
                    })
                    .catch(error => {
                        console.error('删除失败:', error);
                        this.$message.error('删除角色失败');
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },

        // 11. 打开权限配置弹窗（核心修复）
        handleAuth(row) {
            console.log('当前角色:', row);
            this.currentRoleId = row.id;
            this.authDialogVisible = true;

            this.$nextTick(async () => {
                try {
                    // 先加载权限树数据，再初始化勾选状态
                    await this.getAuthTreeData();
                    this.initAuthCheckStatus();
                } catch (error) {
                    console.error('加载权限数据失败:', error);
                    this.$message.error('加载权限数据失败，请重试');
                }
            });
        },

        // 辅助方法4：初始化权限树勾选状态
        initAuthCheckStatus() {
            if (!this.$refs.authTreeRef) {
                console.warn('权限树组件尚未初始化完成');
                return;
            }
            // 清空之前的勾选状态
            this.$refs.authTreeRef.setCheckedKeys([]);
            // 重新收集status为'1'的节点ID
            this.checkedAuthIds = [];
            this.traverseTree(this.authTree);
            // 设置勾选状态
            this.$refs.authTreeRef.setCheckedKeys(this.checkedAuthIds);
            this.tempCheckedIds = [...this.checkedAuthIds];
            this.checkRecords = [];
        },

        // 递归遍历树结构，收集status为'1'的节点ID
        traverseTree(nodes) {
            if (!nodes || !Array.isArray(nodes)) return;
            nodes.forEach(node => {
                if (node.id && node.status === '1') {
                    this.checkedAuthIds.push(node.id);
                }
                if (node.children && node.children.length > 0) {
                    this.traverseTree(node.children);
                }
            });
        },

        // 12. 监听权限树勾选变化
        handleTreeCheck(currentNode, checked) {
            const id = currentNode.id;
            if (!id) return;

            const isChecked = checked.checkedKeys.includes(id);
            const status = isChecked ? '1' : '0';

            // 去重：按id删除旧记录
            this.checkRecords = this.checkRecords.filter(record => record.id !== id);
            this.checkRecords.push({ id, status, time: new Date().getTime() });

            // 更新临时勾选ID和节点status
            this.tempCheckedIds = checked.checkedKeys;
            this.updateSingleNodeStatus(this.authTree, id, status);
        },

        // 单独更新某个节点的status状态
        updateSingleNodeStatus(nodes, targetId, status) {
            if (!nodes || !Array.isArray(nodes)) return false;
            for (const node of nodes) {
                if (node.id === targetId) {
                    node.status = status;
                    return true;
                }
                if (node.children && node.children.length > 0) {
                    const found = this.updateSingleNodeStatus(node.children, targetId, status);
                    if (found) return true;
                }
            }
            return false;
        },

        // 13. 保存权限配置
        async saveAuth() {
            if (this.checkRecords.length === 0) {
                this.$message.info('未修改任何权限配置');
                this.authDialogVisible = false;
                return;
            }

            this.saveAuthLoading = true;
            let successCount = 0;

            try {
                // 批量保存权限配置
                for (const record of this.checkRecords) {
                    const params = {
                        roleId: this.currentRoleId,
                        id: record.id,
                        status: record.status,
                        userId: this.userId
                    };

                    const response = await editPermission(params);
                    if (response.code === 200) {
                        successCount++;
                    } else {
                        console.error(`权限id: ${record.id} 保存失败:`, response.message);
                    }
                }

                this.$message.success(`权限配置完成！成功${successCount}条，失败${this.checkRecords.length - successCount}条`);
                this.authDialogVisible = false;
                this.checkRecords = [];
                this.getList()
            } catch (error) {
                console.error('权限保存出错:', error);
                this.$message.error('权限配置失败，请重试');
            } finally {
                this.saveAuthLoading = false;
            }
        },

        // 14. 表格选择处理
        handleSelectionChange(selection) {
            this.selectedIds = selection.map(item => item.roleId || item.id);
        },

        // 15. 分页大小改变
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.paginateData();
        },

        // 16. 当前页改变
        handleCurrentChange(val) {
            this.currentPage = val;
            this.paginateData();
        },

        // 17. 日期格式化
        formatDate(dateStr) {
            if (!dateStr) return '';
            try {
                const date = new Date(dateStr);
                if (isNaN(date.getTime())) return dateStr;
                return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
            } catch (error) {
                return dateStr;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.personnel-management {
    padding: 20px;
    // background-color: #f5f7fa;
    min-height: calc(100vh - 64px);

    .search-panel {
        background-color: #fff;
        border-radius: 4px;
        padding: 16px;
        margin-bottom: 24px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);

        .search-form {
            display: flex;
            flex-wrap: wrap;
            gap: 16px;

            .form-item {
                margin-bottom: 0;

                &.operate-btns {
                    margin-left: auto;
                }
            }
        }
    }

    .table-container {
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
        margin-bottom: 24px;

        .personnel-table {
            width: 100%;

            .edit-btn {
                color: #67c23a;
            }

            .delete-btn {
                color: #f56c6c;
            }

            .auth-btn {
                color: #409eff;
            }

            .status-active {
                color: #409eff;
                background-color: rgba(64, 158, 255, 0.1);
                padding: 2px 8px;
                border-radius: 4px;
                font-size: 12px;
            }

            .status-inactive {
                color: #909399;
                background-color: rgba(144, 147, 153, 0.1);
                padding: 2px 8px;
                border-radius: 4px;
                font-size: 12px;
            }
        }
    }

    .pagination-container {
        display: flex;
        justify-content: flex-end;
        padding: 10px 0;

        .pagination {
            margin: 0;
        }
    }

    .auth-container {
        max-height: 400px;
        overflow-y: auto;
        padding-right: 10px;

        ::v-deep .el-tree-node__content {
            height: 36px;
            line-height: 36px;
        }
    }

    .form-modal {
        ::v-deep .el-form-item {
            margin-bottom: 16px;
        }
    }
}
</style>